import React, { useState } from 'react';
import { Trash2, Plus, Search } from 'lucide-react';
import { IDX_SEARCH_URL } from '../../constants/site';

const SavedSearchInput = ({ onAdd }) => {
  const [label, setLabel] = useState('');
  const submit = () => {
    const value = label.trim();
    if (!value) return;
    setLabel('');
    onAdd(value);
  };
  return (
    <div className="flex gap-2 mb-6">
      <input
        data-testid="favorite-input"
        value={label}
        onChange={(e) => setLabel(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && submit()}
        placeholder="e.g. Oceanfront condos in Sandbridge"
        className="flex-1 px-4 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-gold-400"
      />
      <button type="button" data-testid="favorite-add" onClick={submit} className="flex items-center space-x-1 bg-gradient-to-r from-gold-400 to-gold-500 text-[#143160] font-bold px-4 rounded-xl hover:scale-105 transition-transform"><Plus className="w-4 h-4" /><span>Save</span></button>
    </div>
  );
};

const SavedSearchItem = ({ fav, onRemove }) => (
  <li className="flex items-center justify-between bg-sand-50 rounded-xl px-4 py-3">
    <a href={`${IDX_SEARCH_URL}#${encodeURIComponent(fav.value || fav.label)}`} target="_blank" rel="noopener noreferrer" className="flex items-center space-x-2 text-[#143160] font-medium hover:underline">
      <Search className="w-4 h-4 text-gold-600" /><span>{fav.label}</span>
    </a>
    <button type="button" data-testid={`favorite-remove-${fav.id}`} onClick={() => onRemove(fav.id)} aria-label="Remove saved search" className="text-red-500 hover:text-red-700"><Trash2 className="w-4 h-4" /></button>
  </li>
);

export const SavedSearches = ({ favorites, onAdd, onRemove }) => (
  <div className="bg-white rounded-2xl shadow border border-gray-100 p-6">
    <h2 className="font-serif text-2xl text-[#143160] mb-4">My Saved Searches</h2>
    <SavedSearchInput onAdd={onAdd} />
    {favorites.length === 0 ? (
      <p className="text-neutral-500 text-sm">No saved searches yet. Save the coastal searches you care about and revisit them anytime.</p>
    ) : (
      <ul className="space-y-2" data-testid="favorites-list">
        {favorites.map((f) => <SavedSearchItem key={f.id} fav={f} onRemove={onRemove} />)}
      </ul>
    )}
  </div>
);
